<template>
  <div class="divs">
    <div class="froms">
      <div class="tilte">项目信息查询</div>
      <div class="separate"></div>
      <div>
        <el-form :model="prop" class="from" :rules="rule">
          <div style="width: 3%"></div>
          <el-form-item label="企业名称：" prop="qymc">
            <el-input v-model="prop.qymc" class="data_input" />
          </el-form-item>
          <el-form-item label="项目名称：" prop="xmmc">
            <el-input v-model="prop.xmmc" class="data_input" />
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="QueryProject()">查询</el-button>
          </el-form-item>
          <div style="width: 3%"></div>
        </el-form>
      </div>
    </div>

    <div class="tables">
      <blockquote style="border-left: 0.2rem solid #ef701d">
        <p style="margin: 0;text-align: left;padding-left: 10px">仅展示前10条信息，如未找到您需要的信息，请尽量完善您的查询条件。</p>
      </blockquote>
      <table class="table">
        <tr class="table_1">
          <td style="width: 100px;">序号</td>
          <td>开发项目</td>
          <td>开发企业</td>
          <td>操作</td>
        </tr>
        <template v-for="(item,index) of enterpriseList.data" :key="item.id">
          <tr>
            <td style="width: 100px;">
              <span>{{ index + 1 }}</span>
            </td>
            <td style="width:45%">
              <span>{{ item.xmmc }}</span>
            </td>
            <td style="">
              <span>{{ item.qymc }}</span>
            </td>
            <td style="">
              <a :href='item.url' target="_blank">查看详情</a>
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script setup>
  import { reactive } from 'vue';
  import { ElMessage } from 'element-plus'
  import { GetProjectData } from "@/api/inquiry";

  const prop = reactive({
    qymc: '',
    xmmc: ''
  });

  const enterpriseList = reactive({
    data: [],
  });

  const QueryProject = async () => {
    if (prop.xmmc !== '') {
      const { data } = await GetProjectData(prop);
      if (data) {
        if (data.length == 0) {
          ElMessage('未查询到项目数据.');
        } else {
          enterpriseList.data = data;
        }
      } else {
        ElMessage('未查询到项目数据.');
      }
    } else {
      ElMessage('请检查查询条件是否全部输入.');
    }
  };

  const rule = {
    xmmc: [{
      required: true,
      message: '请输入项目名称',
      trigger: 'blur',
    }],
  }


</script>

<style lang="scss" scoped>
  .from {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    margin-top: 1.5%;
  }

  .froms {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 130px;
    width: 100%;
  }

  .tilte {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ef701d;
    height: 40%;
    width: 100%;
    color: white;
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
  }

  .separate {
    width: 100%;
    height: 5%;
    background-color: #ca5f18;
  }

  .query {
    background-color: #EF701D;
    border: 0px solid white;
    color: white;
    width: 7%;
  }

  .data_input,
  .data_select {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
  }

  .tables {
    width: 90%;
  }

  .table {
    margin-top: -12px;
    border: 1px solid #E3AB68;
    width: 100%;
    border-collapse: collapse;
  }

  td {
    border: 1px solid #E3AB68;
    height: 30px;
  }

  .table_1 {
    background-color: #E3AB68;
  }

  .divs {
    width: 98%;
    height: 98%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    border: 1px solid orange;
    border-radius: 10px;
  }
</style>